import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import {
  ButtonComponent,
  FormGroupComponent,
  FormsUtil,
  InputComponent,
  InputPasswordComponent,
  ModalComponent,
  ModalFooterDirective
} from 'mbs-ui-kit';
import { MyTreeElements } from 'mbs-ui-shared@models/backup/storages-type';

type CredentialsForm = {
  login: FormControl<string>;
  password: FormControl<string>;
};

@Component({
  selector: 'mbs-credentials-modal',
  templateUrl: './credentials-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormGroupComponent,
    ButtonComponent,
    I18NextPipe,
    ModalComponent,
    InputComponent,
    InputPasswordComponent,
    ModalFooterDirective
  ]
})
export class CredentialsModalComponent implements OnInit {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public root: MyTreeElements;

  public form: FormGroup<CredentialsForm> = new FormGroup<CredentialsForm>({
    login: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });

  ngOnInit(): void {
    if (this.baseModal.data) {
      this.root = this.baseModal.data.root;
    }
  }

  saveCredentials(): void {
    FormsUtil.triggerValidation(this.form);

    if (this.form.invalid) return;

    const value = this.form.value;

    this.baseModal.save(value);
  }

  cancelClickHandler(): void {
    this.baseModal.close();
  }
}
